import { Config } from '../utils'
import ApiController from './api'
import { Endpoints } from './types'

export const endpoints: Endpoints = {
  getPrimaryMenu: {
    method: 'GET',
    url: '/megamenu',
  },
  getMegamenu: {
    method: 'GET',
    url: '/megamenu',
  },
}

export class WooptimaAPI extends ApiController {
  getMegamenuData = async (menuID: string | number) =>
    this.request({ endpoint: endpoints.getPrimaryMenu, query: menuID, additionalArgs: {
      params:
        Config.REACT_APP_ENV === 'staging' ? {
          include: ['theme', 'config'].join(',')
        } : {},
    } })
}
